import React from 'react';
import { withTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import CourseInfoPanelView from './CourseInfoPanel.view';
const items = (values, t) => {
  const { coursePackage, instructor, subsectionCount, totalTime, timeLeft, expiryDate } =
    values || {};
  return [
    { left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_1.KEY'), right: coursePackage },
    { left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_2.KEY'), right: instructor },
    { left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_3.KEY'), right: subsectionCount },
    { left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_4.KEY'), right: totalTime },
    {
      left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_5.KEY'),
      right: timeLeft,
      rightProps: { color: 'danger' },
    },
    {
      left: t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_6.KEY'),
      right: expiryDate
        ? t('COURSE_INFO_PANEL.LIST_ITEMS.ITEM_6.VALUE', {
            expDate: dayjs(expiryDate).add(-1, 'minute'),
          })
        : null,
    },
  ];
};

const CourseInfoPanel = ({
  t,
  coursePackage,
  instructor,
  subsectionCount,
  totalTime,
  timeLeft,
  expiryDate,
  ...restProps
}) => {
  const courseInfoListItems = items(
    {
      coursePackage,
      instructor,
      subsectionCount,
      totalTime,
      timeLeft,
      expiryDate,
    },
    t
  );

  return <CourseInfoPanelView courseInfoListItems={courseInfoListItems} {...restProps} />;
};

export default withTranslation('classroom')(CourseInfoPanel);
